import app from '../../scripts/app';
import { trackSelectIdentification } from './verification-task.tracking';
import template from './verification-task.jade';
import { selectBillingProblemReasons } from '../../../../shared/selectors/billingStatus';

const verificationTaskController = [
  '$scope',
  '$rootScope',
  '$timeout',
  'userIdentificationService',
  'store',
  function ($scope, $rootScope, $timeout, userIdentificationService, store) {
    const state = store.getState();
    const billingProblemReasons = selectBillingProblemReasons(state);

    $scope.getTask = () => {
      return userIdentificationService
        .getTaskList()
        .find(item => item.identificationServiceType === $scope.task.identificationServiceType);
    };

    $scope.$watch(
      userIdentificationService.getUserStatus,
      (newVal, oldVal) => {
        if ($scope.task.identificationServiceType === 'gosuslugi') {
          if (newVal === 'identified' || oldVal === 'identified') {
            userIdentificationService.setIsSelectPageVisible(false);
            userIdentificationService.resetGosuslugiPromise();
            $rootScope.$emit('callShowPublishSuccess');
          } else {
            userIdentificationService.checkAvailableTasks().then(() => {
              $timeout(function () {
                $scope.$apply();
              });
            });
            if (newVal === 'previousAttemptFailedShouldRetry') {
              userIdentificationService.resetGosuslugiPromise();
            }
          }
        }
      },
      true,
    );

    this.onSelect = () => {
      trackSelectIdentification($scope.task.analyticsKey);
      userIdentificationService.onSelectIdentification($scope.task);
    };

    $scope.billingProblemReason = billingProblemReasons.identification;
  },
];

const verificationTaskDirective = [
  function () {
    return {
      template,
      scope: {
        task: '=',
      },
      bindToController: {},
      controller: verificationTaskController,
      controllerAs: 'verificationTaskCtrl',
    };
  },
];

app.directive('verificationTask', verificationTaskDirective);
